import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const NetworkButtonContainer = styled.div<React.CSSProperties>`
  display: flex;
  justify-content: center;
  position: relative;
  top: ${Screen.widthRatio * 620}px;
`;

export default NetworkButtonContainer;
